import React from "react";

export type ColumnDef<T> = {
  header: string;
  render: (row: T) => React.ReactNode;
  span?: number;
  className?: string;
};

export type GenericGroupTableProps<T> = {
  columns: Array<ColumnDef<T>>;
  items: Array<T & { id: string }>;
};

export function GroupTable<T>({ columns, items }: GenericGroupTableProps<T>) {
  const tableWidth = columns.length * 140;
  const template = {
    gridTemplateColumns: `repeat(${columns.length}, minmax(140px, 1fr))`,
  } as React.CSSProperties;

  return (
    <div className="cx-bg-white cx-rounded-lg cx-shadow-sm cx-border cx-border-neutral-light cx-mt-3 cx-overflow-x-auto">
      <div className="cx-py-3" style={{ minWidth: tableWidth }}>
        <div
          className="cx-grid cx-gap-4 cx-text-text-secondary cx-text-sm cx-font-medium cx-py-3 cx-px-4"
          style={template}
        >
          {columns.map((c, idx) => (
            <div
              key={`header-${idx}`}
              className={`cx-whitespace-nowrap ${c.className || ""}`}
            >
              {c.header}
            </div>
          ))}
        </div>
        <div className="cx-border-b cx-border-heavy" />
        <div className="cx-divide-y cx-divide-neutral-light">
          {items.map((row: any) => (
            <div
              key={row.id}
              className="cx-grid cx-gap-4 cx-items-center cx-py-5 cx-px-4"
              style={template}
            >
              {columns.map((c, idx) => (
                <div
                  key={`cell-${row.id}-${idx}`}
                  className={`cx-text-text-primary cx-text-sm cx-whitespace-nowrap ${
                    c.className || ""
                  }`}
                >
                  {c.render(row)}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GroupTable;
